<script>
    import GeneralDetailPage from "./GeneralDetailPage.svelte";
    import {_} from "svelte-i18n";

</script>

<GeneralDetailPage title={$_("imprint")}>
    <div slot="content">
        <h3>{$_("imprint_title")}</h3>
        <p>Fondation Beyeler</p>
        <div>
            <p>
                Digitale Kommunikation
                <br/>
                Baselstrasse 77
                <br/>4125
                Riehen/Basel
                <br/>Schweiz<br/>
                <a
                        href="mailto:kommunikation@fondationbeyeler.ch"
                >kommunikation@fondationbeyeler.ch</a
                >
            </p>
            <p>&nbsp;</p>
            <p>
                { $_("imprint_text")}
            </p>
        </div>
    </div>
</GeneralDetailPage>
